<template>
  <div class="activity container">
    <CustomerService></CustomerService>
    <Carousel height="607.5px" theme="banner" :list="banner" />
    <div class="page-intro text-center" v-if="pmsProductPage">
      <div class="page-title">
        <div class="tag" v-if="pmsProductPage.productType_translate">{{ pmsProductPage.productType_translate }}</div>
        <h1>{{ pmsProductPage.name }}</h1>
      </div>
      <div  class="page-content" v-if="pmsProductPage.productSaleScope">
        <p style="white-space: pre-line;text-align:center" v-if="pmsProductPage.pageText">{{ pmsProductPage.pageText }}</p>
        <div class="tips" v-if="hotelName">
          *** {{ pmsProductPage.productType_translate }} {{ ts('provide to')['provide to'] }} : {{ ts('Guests stay in')['Guests stay in'] }} <span>{{ hotelName }}</span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="activity-list" :class="{ 'product-list': productType == '1', 'service-list': productType == '3' }">
        <ProductItem v-for="(item, index) in list" :key="index" type="order" :item="item" :parentId="$route.params.id" :productPage="pmsProductPage" />
      </div>
      <OtherSwiper />
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Carousel from '@/components/Carousel.vue'
import ProductItem from '@/components/ProductItem.vue'
import OtherSwiper from '@/components/OtherSwiper.vue'
import CustomerService from '@/components/CustomerService.vue'

export default {
  name: 'Product',
  mixins: [LanguagePackage],
  components: {
    Carousel,
    ProductItem,
    OtherSwiper,
    CustomerService,
  },
  data() {
    return {
      banner: [],
      list: [],
      pmsProductPage: null,
      hotelName: null,
      productType: null,
    }
  },
  created() {
    this.getList()
  },
  watch: {
    $route() {
      this.getList()
    },
  },
  methods: {
    // 查询产品列表
    getList() {
      getAction(`/pc/home/qryProductList`, {
        pageId: this.$route.params.id,
      }).then((res) => {
        this.list = res.result.singleProductList
        this.banner = res.result.pageMainImg
        this.pmsProductPage = res.result.pmsProductPage
        this.productType = res.result.pmsProductPage.productType
        const hotelName = res.result.hotelName
        if (hotelName) {
          // hotelName.split(',')
          this.hotelName = hotelName
        }
      })
    },
  },
}
</script>
